import { createAction } from '@reduxjs/toolkit';

import { createAPIActions } from 'utils/common';

import type { WallPreview } from './wall_previews.types';

const getAll = createAPIActions<void, WallPreview[]>('wallPreviews', 'getAll');

const saveWallPreview = {
  pending: createAction<string>('wallPreviews/saveWallPreview/pending'),
  fulfilled: createAction<WallPreview>('wallPreviews/saveWallPreview/fulfilled'),
  rejected: createAction('wallPreviews/saveWallPreview/rejected'),
};

const destroy = createAPIActions<number, number>('wallPreviews', 'destroy');

export default {
  getAll,
  saveWallPreview,
  destroy,
};
